'use client';

import Image from "next/image";
import s from './Journals.module.scss';
import Columns from "../home/columns";
import Centered from "../home/centered";
import Highlight from "../home/highlight";
import Complex from "../home/complex";
import { useEffect, useState } from "react";
import JournalsFilterComponent from "./filter";
import { motion } from "framer-motion";
import JournalFeaturedComponent from "@/components/singles/journalFeatured";

interface DataProps {
    data: any;
    categories: any;
    journals: any;
}

export default function JournalsComponent({ data, categories, journals }: DataProps) {
    const [filterCategories, setFilterCategories] = useState<Array<string>>(['ALL']);
    const [filtered, setFiltered] = useState<boolean>(false);
    const [filteredJournals, setFilteredJournals] = useState<Array<DataProps>>(journals);

    // Función para aplicar los filtros
    useEffect(() => {
        const updatedJournals =journals.filter((journal: any) => {
            // Si "ALL" está seleccionado en una categoría, no filtramos por ella
            const categoryMatch = filterCategories.includes("ALL") || (journal.categories ?? []).some((t: any) => filterCategories.includes(t.title));

            if(filterCategories.includes("ALL")) {
                setFiltered(false);
            } else {    
                setFiltered(true);
            }
            
            return categoryMatch;
        });
        setFilteredJournals(updatedJournals);

        window.scrollTo({ top: 0 });

    }, [filterCategories, journals, setFiltered]);

    return (
        <div className={s.journals}>
            <div className={s.title}>
                <h1>Journal</h1>
            </div>
            <JournalsFilterComponent 
                categories={categories}
                onFilterChange={(filters: any) => {
                    // Aquí puedes actualizar los estados según corresponda
                    setFilterCategories(filters.categories || ['ALL']);

                }}
                filterCategories={filterCategories}
            />
            {filterCategories.includes('ALL') ? data && data.layout && data.layout.map((item: any, index: any) => {
                if(item._type == 'module.columns'){
                    return (
                        <section className={s.sectionColumns} key={`module-${index}-${item._type}`}>
                            <Columns data={item} />
                        </section>
                    )
                } else if (item._type == 'module.centered'){
                    return (
                        <section className={s.sectionCentered} key={`module-${index}-${item._type}`}>
                            <Centered data={item} />
                        </section>
                    )
                } else if (item._type == 'module.highlight'){
                    return (
                        <section className={s.sectionHighlight} key={`module-${index}-${item._type}`}>
                            <Highlight data={item} />
                        </section>
                    )
                } else if (item._type == 'module.complex'){
                    return (
                        <section className={s.sectionComplex} key={`module-${index}-${item._type}`}>
                            <Complex data={item} />
                        </section>
                    )
                }
            }) : 
                <>
                <div className={s[`columns3`]}>
                    {filteredJournals.map((journal: any, index: any) => (
                        <motion.div  
                        className={s.column} 
                        key={`journal-${index}`}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: Math.min(index * 0.1, 0.5) }}
                        viewport={{ once: true }}>
                            <JournalFeaturedComponent data={journal} />
                        </motion.div>
                    ))}
                </div>
                </>
            }
        </div>
    );
}


